import { Badge, Card, HStack, Skeleton, Stack } from "@chakra-ui/react";

export const CardsSkeleton = () => {
  return (
    <Stack width="100%">
      <Card.Root size="sm">
        <Card.Body color="fg.muted">
          <Card.Description>
            <HStack width="100%">
              <Skeleton asChild loading={true} width="100%" variant="shine">
                <Badge>Select</Badge>
              </Skeleton>
            </HStack>
            <br />
            <HStack width="100%">
              <Skeleton asChild loading={true} width="100%" variant='pulse'>
                <Badge>Select</Badge>
              </Skeleton>
            </HStack>
            <br />
            <HStack width="100%">
              <Skeleton asChild loading={true} width="100%" variant="shine">
                <Badge>Select</Badge>
              </Skeleton>
            </HStack>
          </Card.Description>
        </Card.Body>
      </Card.Root>
    </Stack>
  );
};
